<template>
  <component :is="current" v-bind="$attrs" />
</template>

<script setup>
import { useUiWrapper } from '@/utils/uiWrapper'
import FooterViewOld from './Old/OldXMLFileDIfference.vue'
import NewFooterView from './New/NewXMLFileDIfference.vue'

const current = useUiWrapper(FooterViewOld, NewFooterView)
</script>
